import { all, call, put, takeEvery } from 'redux-saga/effects'
import * as subscriptionProviders from 'services/subscription'
import actions from './actions'

export function* LOAD_SUBSCRIPTION() {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const response = yield call(subscriptionProviders.loadSubscription)
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        data: response.subscription,
      },
    })
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* LOAD_PRODUCTS() {
  yield put({
    type: actions.SET_PRODUCTS_STATE,
    payload: {
      loading: true,
    },
  })
  const response = yield call(subscriptionProviders.loadProducts)
  if (response) {
    yield put({
      type: actions.SET_PRODUCTS_STATE,
      payload: {
        data: response.products,
      },
    })
  }
  yield put({
    type: actions.SET_PRODUCTS_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* LOAD_SHOPIFY_PRODUCTS() {
  yield put({
    type: actions.SET_SHOPIFY_PRODUCTS_STATE,
    payload: {
      loading: true,
    },
  })
  const response = yield call(subscriptionProviders.loadShopifyProducts)
  if (response) {
    yield put({
      type: actions.SET_SHOPIFY_PRODUCTS_STATE,
      payload: {
        data: response.products,
      },
    })
  }
  yield put({
    type: actions.SET_SHOPIFY_PRODUCTS_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* LOAD_INVOICES() {
  yield put({
    type: actions.SET_INVOICES_STATE,
    payload: {
      loading: true,
    },
  })
  const response = yield call(subscriptionProviders.loadInvoices)
  if (response) {
    yield put({
      type: actions.SET_INVOICES_STATE,
      payload: {
        data: response.invoices,
      },
    })
  }
  yield put({
    type: actions.SET_INVOICES_STATE,
    payload: {
      loading: false,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD_SUBSCRIPTION, LOAD_SUBSCRIPTION),
    takeEvery(actions.LOAD_PRODUCTS, LOAD_PRODUCTS),
    takeEvery(actions.LOAD_SHOPIFY_PRODUCTS, LOAD_SHOPIFY_PRODUCTS),
    takeEvery(actions.LOAD_INVOICES, LOAD_INVOICES),
  ])
}
